import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { selectors } from '@/redux/accommodation/hotel/view/model';
import ReservationList from './ReservationList';
import Filters from './Filters';

const Reservation = ({ fetchMore }) => {
    const roomList = useSelector(selectors.roomList);
    const { general_data: generalData } = useSelector(selectors.accommodationDetails);
    const accommodationId = generalData.id;
    const isLoadingMore = useSelector(selectors.isLoadingMore);
    const hasMore = useSelector(selectors.hasMore);
    const filterData = useSelector(selectors.filterData);

    return (
        <>
            <Filters filterData={filterData} />
            {roomList.length !== 0 && (
                <>
                    <ReservationList
                        data={roomList}
                        accommodationId={accommodationId}
                        filterData={filterData}
                    />
                    {!isLoadingMore && hasMore && (
                        <Waypoint onEnter={fetchMore} />
                    )}
                </>
            )}
        </>
    );
};

export default Reservation;
